module.exports = __webpack_public_path__ + "static/media/soul-modal-close.a6b6df92.svg";